/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * The credentials used to login a user, starting a session.
 */
export type LoginRequest = {
    /**
     * The email address that identifies the user.
     */
    email: string;
    /**
     * The password that is assigned to the user.
     */
    password: string;
    /**
     * An optional role that the client assumes during this session.
     */
    role?: LoginRequest.role;
    /**
     * A name for the session, e.g., that identifies the client device.
     */
    sessionName: string;
    /**
     * The one-time password for Multi-Factor-Authentication.
     */
    mfaToken?: string;
};

export namespace LoginRequest {

    /**
     * An optional role that the client assumes during this session.
     */
    export enum role {
        ANONYMOUS = 'ANONYMOUS',
        CHANGE_PASSWORD = 'CHANGE_PASSWORD',
        API_DOCUMENTATION = 'API_DOCUMENTATION',
        USER = 'USER',
        STAFF_VIEW_ONLY = 'STAFF_VIEW_ONLY',
        STAFF = 'STAFF',
        STAFF_ADMIN_ACCESS = 'STAFF_ADMIN_ACCESS',
        STAFF_CUSTOMER_SUPPORT = 'STAFF_CUSTOMER_SUPPORT',
        STAFF_DIABETES_EDUCATOR = 'STAFF_DIABETES_EDUCATOR',
        STAFF_KNOWLEDGE_BASE_EDITOR = 'STAFF_KNOWLEDGE_BASE_EDITOR',
        STAFF_MEDICATION_ADMIN = 'STAFF_MEDICATION_ADMIN',
        STAFF_1099_HEALTH_COACH = 'STAFF_1099_HEALTH_COACH',
        STAFF_PROVIDER = 'STAFF_PROVIDER',
        STAFF_PHYSICIAN = 'STAFF_PHYSICIAN',
        STAFF_PHYSICIAN_ASSISTANT = 'STAFF_PHYSICIAN_ASSISTANT',
        STAFF_NURSE_PRACTITIONER = 'STAFF_NURSE_PRACTITIONER',
        DEVELOPER = 'DEVELOPER',
        TRUSTED_DEVICE = 'TRUSTED_DEVICE',
        STAFF_USER_ADMIN = 'STAFF_USER_ADMIN',
        SUPER_ADMIN = 'SUPER_ADMIN',
    }


}

